import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaTrash, FaSave } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { addDevis } from "../services/DevisService";
import { useSelector } from "react-redux";
import { getClient } from "../services/ClientService";
import { getAutres, getBatiment } from "../services/SecteurServices";
import { tvainfo } from "../services/LoginService"; // import de ta fonction Me()
import * as LoadingIcons from "react-loading-icons";
const AddDevis = () => {
    const token = useSelector((state) => state.auth.token);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    const [tva_inclus, setTvaInclus] = useState(false);
    const [activeRates, setActiveRates] = useState([]);
    const [clients, setClients] = useState([]);
    const [selectedClient, setSelectedClient] = useState(null);
    const [secteursBatiment, setSecteursBatiment] = useState([]);
    const [secteursAutres, setSecteursAutres] = useState([]);
    const [selectedBatiment, setSelectedBatiment] = useState([]);
    const [selectedAutres, setSelectedAutres] = useState([]);

    const [devis, setDevis] = useState({
        numero: "",
        date_emission: new Date().toISOString().slice(0, 10),
        date_expiration: "",
        statut: "brouillon",
        titre: "",
        notes_client: "",
        notes_internes: "",
        acompte_centimes: 0,
        lignes: [
            {
                designation: "",
                quantite: 1,
                unite: "",
                prix_unitaire_centimes: 0,
                taux_tva: 0,
                taux_remise: 0,
                total_ligne_centimes: 0,
            },
        ],
    });



    const statuts = [
        { label: "Brouillon", value: "brouillon" },
        { label: "Envoyé", value: "envoye" },
        { label: "Accepté", value: "accepte" },
        { label: "Refusé", value: "refuse" },
        { label: "Expiré", value: "expire" },
        { label: "Transformé", value: "transforme" },
    ];

    const [totaux, setTotaux] = useState({
        sous_total_centimes: 0,
        remise_centimes: 0,
        tva_centimes: 0,
        total_centimes: 0,
    });

    useEffect(() => {
        if (!token) {
            navigate("/login", { state: { message: "Session expirée" } });
            return;
        }

        const fetchData = async () => {
            try {
                const resTVA = await tvainfo(token);
                let inclus = false;
                let active = [];
                if (resTVA.success) {
                    inclus = resTVA.tva_inclus ?? false;
                    const rates = resTVA.tva_rates || {};
                    active = Object.keys(rates)
                        .filter((k) => rates[k])
                        .sort((a, b) => parseFloat(a) - parseFloat(b));
                }
                setTvaInclus(inclus);
                setActiveRates(active);

                const clientsRes = await getClient(token);
                setClients(clientsRes);

                const batimentRes = await getBatiment(token);
                const autresRes = await getAutres(token);
                setSecteursBatiment(batimentRes);
                setSecteursAutres(autresRes);

                setLoading(false);
            } catch (err) {
                console.error(err);
                toast.error("Erreur lors du chargement des données.");
            }
        };

        fetchData();
    }, [token, navigate]);

    useEffect(() => {
        if (activeRates.length > 0) {
            setDevis((d) => {
                const newLignes = [...d.lignes];
                newLignes[0].taux_tva = newLignes[0].taux_tva || parseFloat(activeRates[0]);
                return { ...d, lignes: newLignes };
            });
        }
    }, [activeRates]);

    const addLigne = () => {
        setDevis({
            ...devis,
            lignes: [
                ...devis.lignes,
                {
                    designation: "",
                    quantite: 1,
                    unite: "",
                    prix_unitaire_centimes: 0,
                    taux_tva: activeRates[0] ? parseFloat(activeRates[0]) : 0,
                    taux_remise: 0,
                    total_ligne_centimes: 0,
                },
            ],
        });
    };

    const removeLigne = (index) => {
        const newLignes = [...devis.lignes];
        newLignes.splice(index, 1);
        setDevis({ ...devis, lignes: newLignes });
    };

    const updateLigne = (index, field, value) => {
        const newLignes = [...devis.lignes];
        newLignes[index][field] = value;

        const prix = parseFloat(newLignes[index].prix_unitaire_centimes) || 0;
        const quantite = parseFloat(newLignes[index].quantite) || 0;
        const remise = parseFloat(newLignes[index].taux_remise) || 0;
        const tauxTVA = parseFloat(newLignes[index].taux_tva) || 0;

        const ligneTotal = prix * quantite;
        const ligneRemise = (ligneTotal * remise) / 100;
        const ligneHT = ligneTotal - ligneRemise;
        const ligneTVA = (ligneHT * tauxTVA) / 100;

        newLignes[index].total_ligne_centimes = ligneHT + ligneTVA;

        setDevis({ ...devis, lignes: newLignes });
    };

    const tvaParTaux = React.useMemo(() => {
        const result = {};
        activeRates.forEach((rate) => (result[rate] = 0));

        devis.lignes.forEach((ligne) => {
            const totalHT = parseFloat(ligne.total_ligne_centimes) || 0;
            const taux = (parseFloat(ligne.taux_tva) || 0).toFixed(2);
            if (result.hasOwnProperty(taux)) {
                result[taux] += (totalHT * parseFloat(taux)) / 100;
            } else {
                result[taux] = (totalHT * parseFloat(taux)) / 100;
            }
        });

        return result;
    }, [devis.lignes, activeRates]);

    useEffect(() => {
        let sousTotal = 0, remise = 0, tva = 0;

        devis.lignes.forEach((ligne) => {
            const prix = parseFloat(ligne.prix_unitaire_centimes) || 0;
            const quantite = parseFloat(ligne.quantite) || 0;
            const remiseLigne = parseFloat(ligne.taux_remise) || 0;
            const tauxTVA = parseFloat(ligne.taux_tva) || 0;

            const ligneTotal = prix * quantite;
            const ligneRemise = (ligneTotal * remiseLigne) / 100;
            const ligneHT = ligneTotal - ligneRemise;
            const ligneTVA = (ligneHT * tauxTVA) / 100;

            sousTotal += ligneHT;
            remise += ligneRemise;
            tva += ligneTVA;

            ligne.total_ligne_centimes = ligneHT;
        });

        setDevis((d) => ({ ...d }));
        setTotaux({
            sous_total_centimes: sousTotal,
            remise_centimes: remise,
            tva_centimes: tva,
            total_centimes: sousTotal + tva,
        });
    }, [devis.lignes]);

    const handleSave = async () => {
        if (!selectedClient) { toast.error("Veuillez sélectionner un client."); return; }
        const lignesValides = devis.lignes.filter(l => l.designation?.trim() && parseFloat(l.prix_unitaire_centimes) > 0);
        if (!lignesValides.length) { toast.error("Veuillez ajouter au moins une ligne valide."); return; }

        try {
            await addDevis({
                ...devis,
                client_id: selectedClient.id,
                lignes: lignesValides,
                secteurs_batiment: selectedBatiment,
                secteurs_autres: selectedAutres,
                sous_total_centimes: totaux.sous_total_centimes,
                remise_centimes: totaux.remise_centimes,
                tva_centimes: totaux.tva_centimes,
                total_centimes: totaux.total_centimes,
            });
            navigate("/EspaceClient/devis", { state: { message: "Devis ajouté avec succès !" } });
        } catch (err) {
            toast.error(err.message || "Erreur lors de l'ajout du devis.");
        }
    };

    if (loading) return (
        <div className="flex flex-col justify-center min-h-screen items-center">
            <LoadingIcons.SpinningCircles stroke="#2218eeff" fill="#2218eeff" strokeWidth={3} height={40} width={40} />
            <span className="ml-3 text-gray-600 font-medium">Chargement</span>
        </div>
    );
    return (
        <div className="min-h-screen p-6 flex flex-col gap-2">
            <div  >
                <ToastContainer position="top-right" autoClose={3000} />
                <div className="flex justify-between items-center mb-2">
                    <h1 className="font-bold text-2xl">Ajouter une devis</h1>
                    <button onClick={handleSave} className="bg-color3 hover:bg-color3/80 text-white px-4 py-2 rounded-lg flex items-center gap-2"><FaSave /> Enregistrer</button>
                </div>

                <div className="flex flex-col gap-5">
                    <div className="bg-white shadow-md rounded-lg p-4">
                        <h2 className="font-semibold mb-4">Informations de la devis</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Client</label>
                                <select className="border rounded-md px-2 py-1" value={selectedClient?.id || ""} onChange={(e) => setSelectedClient(clients.find(c => c.id === Number(e.target.value)))}>
                                    <option value="">-- Sélectionner --</option>
                                    {clients.map(c => <option key={c.id} value={c.id}>{c.nom_affichage} ({c.email || "-"})</option>)}
                                </select>
                            </div>

                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Statut</label>
                                <select className="border rounded-md px-2 py-1" value={devis.statut} onChange={(e) => setDevis({ ...devis, statut: e.target.value })}>
                                    {statuts.map(s => <option key={s.value} value={s.value}>{s.label}</option>)}
                                </select>
                            </div>


                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Date d'émission</label>
                                <input type="date" className="border rounded-md px-2 py-1" value={devis.date_emission} onChange={(e) => { const newDate = e.target.value; setDevis({ ...devis, date_emission: newDate, date_echeance: devis.date_echeance < newDate ? newDate : devis.date_echeance }); }} />
                            </div>

                            <div className="flex flex-col">
                                <label className="mb-1 font-medium">Date d'échéance</label>
                                <input
                                    type="date"
                                    className="border rounded-md px-2 py-1"
                                    value={devis.date_expiration || devis.date_emission} // si vide, fallback sur date_emission
                                    min={devis.date_emission}
                                    onChange={(e) => setDevis({ ...devis, date_expiration: e.target.value })}
                                />
                            </div>

                        </div>
                        <div className="bg-white shadow-md rounded-xl p-6 mb-6">
                            <h2 className="text-lg font-semibold mb-4">Secteurs</h2>

                            {/* Bâtiment */}
                            <h3 className="text-sm font-medium text-gray-600 mb-2">Bâtiment</h3>
                            <div className="flex flex-wrap gap-3 mb-4">
                                {secteursBatiment.map((s) => {
                                    const isSelected = selectedBatiment.includes(s.id);
                                    return (
                                        <button
                                            key={s.id}
                                            type="button"
                                            onClick={() =>
                                                setSelectedBatiment((prev) =>
                                                    prev.includes(s.id)
                                                        ? prev.filter((id) => id !== s.id)
                                                        : [...prev, s.id]
                                                )
                                            }
                                            className={`px-3 py-1 rounded-full text-sm font-medium border transition ${isSelected
                                                ? "bg-green-600 text-white border-green-600 shadow"
                                                : "bg-green-50 text-green-700 border-green-300 hover:bg-green-100"
                                                }`}
                                        >
                                            {s.nom}
                                        </button>
                                    );
                                })}
                            </div>

                            {/* Autres */}
                            <h3 className="text-sm font-medium text-gray-600 mb-2">Autres</h3>
                            <div className="flex flex-wrap gap-3">
                                {secteursAutres.map((s) => {
                                    const isSelected = selectedAutres.includes(s.id);
                                    return (
                                        <button
                                            key={s.id}
                                            type="button"
                                            onClick={() =>
                                                setSelectedAutres((prev) =>
                                                    prev.includes(s.id)
                                                        ? prev.filter((id) => id !== s.id)
                                                        : [...prev, s.id]
                                                )
                                            }
                                            className={`px-3 py-1 rounded-full text-sm font-medium border transition ${isSelected
                                                ? "bg-gray-700 text-white border-gray-700 shadow"
                                                : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
                                                }`}
                                        >
                                            {s.nom}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>

                    </div>

                    {/* Lignes devis */}
                    {/* Lignes devis */}
                    {/* Lignes devis */}
                    <div className="bg-white shadow-md rounded-lg p-4 w-full">
                        <h2 className="font-semibold mb-2">Lignes de devis</h2>

                        <table className="w-full text-sm text-left border-collapse mb-4">
                            <thead className="bg-color1 text-color2 uppercase text-xs font-semibold">
                                <tr>
                                    <th className="px-3 py-2 text-left">Désignation</th>
                                    <th className="px-3 py-2 w-24 text-center">Qté</th>
                                    <th className="px-3 py-2 w-24 text-center">Unité</th>
                                    <th className="px-3 py-2 w-32 text-center">Prix Unitaire</th>
                                    <th className="px-3 py-2 w-24 text-center">TVA (%)</th>
                                    <th className="px-3 py-2 w-24 text-center">Remise (%)</th>
                                    <th className="px-3 py-2 w-32 text-center">Total HT</th>
                                    {devis.lignes.length > 1 && <th className="px-3 py-2 w-16">Action</th>}
                                </tr>
                            </thead>

                            <tbody>
                                {devis.lignes.map((ligne, index) => (
                                    <tr key={index} className="border-b hover:bg-gray-50">
                                        <td className="px-2 py-1">
                                            <textarea
                                                value={ligne.designation}
                                                onChange={(e) => updateLigne(index, "designation", e.target.value)}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1 resize-none"
                                                rows={4}
                                            />
                                        </td>

                                        <td className="px-2 py-1">
                                            <input
                                                type="number"
                                                min={1}
                                                value={ligne.quantite}
                                                onChange={(e) => updateLigne(index, "quantite", e.target.value)}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1"
                                            />
                                        </td>

                                        <td className="px-2 py-1">
                                            <input
                                                type="text"
                                                value={ligne.unite}
                                                onChange={(e) => updateLigne(index, "unite", e.target.value)}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1"
                                            />
                                        </td>

                                        <td className="px-2 py-1">
                                            <input
                                                type="number"
                                                min={0}
                                                value={ligne.prix_unitaire_centimes}
                                                onChange={(e) => updateLigne(index, "prix_unitaire_centimes", e.target.value)}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1"
                                            />
                                        </td>
                                        <td className="px-2 py-1">
                                            {tva_inclus && activeRates.length > 0 ? (
                                                <select
                                                    value={ligne.taux_tva ?? activeRates[0]}   // ⬅️ si pas défini → prend le 1er taux
                                                    onChange={(e) =>
                                                        updateLigne(index, "taux_tva", parseFloat(e.target.value))
                                                    }
                                                    className="w-full border border-gray-300 rounded-md px-1 py-1"
                                                >
                                                    {activeRates.map((taux) => (
                                                        <option key={taux} value={parseFloat(taux)}>
                                                            {taux}
                                                        </option>
                                                    ))}
                                                </select>


                                            ) : (
                                                <p className="text-center">-</p>
                                            )}
                                        </td>


                                        <td className="px-2 py-1">
                                            <input
                                                type="number"
                                                min={0}
                                                max={100}
                                                value={ligne.taux_remise}
                                                onChange={(e) => {
                                                    let value = parseFloat(e.target.value) || 0;
                                                    if (value > 100) value = 100;
                                                    if (value < 0) value = 0;
                                                    updateLigne(index, "taux_remise", value);
                                                }}
                                                className="w-full border border-gray-300 rounded-md px-1 py-1"
                                            />
                                        </td>

                                        <td className="px-2 py-1 font-bold text-center">
                                            {ligne.total_ligne_centimes.toFixed(2)} €
                                        </td>

                                        {devis.lignes.length > 1 && (
                                            <td className="px-2 py-1 text-center">
                                                <button
                                                    onClick={() => removeLigne(index)}
                                                    className="text-red-600 hover:text-red-800"
                                                >
                                                    <FaTrash />
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="flex justify-end mb-4">
                            <button
                                onClick={addLigne}
                                className="bg-color3 hover:bg-color3/80 text-white px-3 py-1 rounded-lg flex items-center gap-1"
                            >
                                <FaPlus /> Ajouter une ligne
                            </button>
                        </div>

                        {/* Totaux */}
                        <div className="grid grid-cols-[140px_120px] gap-y-1 justify-end items-end">

                            {/* Total HT */}
                            <span className="font-bold text-left">Total HT :</span>
                            <span className="text-right">{totaux.sous_total_centimes.toFixed(2)} €</span>

                            {/* Remise */}
                            {totaux.remise_centimes > 0 && (
                                <>
                                    <span className="font-bold text-left">Remise :</span>
                                    <span className="text-right">{totaux.remise_centimes.toFixed(2)} €</span>
                                </>
                            )}

                            {/* TVA par taux */}
                            {tva_inclus && Object.keys(tvaParTaux).length > 0 && (
                                <>
                                    {activeRates.map((rate) => {
                                        const key = parseFloat(rate).toFixed(2); // correspond à la clé dans tvaParTaux
                                        return (
                                            <React.Fragment key={key}>
                                                <span className="font-bold text-left">TVA ({rate}) :</span>
                                                <span className="text-right">{(tvaParTaux[key] || 0).toFixed(2)} €</span>
                                            </React.Fragment>
                                        );
                                    })}

                                    <span className="font-bold text-left">Total TVA :</span>
                                    <span className="text-right">{totaux.tva_centimes.toFixed(2)} €</span>
                                </>
                            )}
                            {/* Total final */}
                            {tva_inclus && (
                                <> <span className="font-bold text-left">Total TTC :</span>
                                    <span className="text-right">{totaux.total_centimes.toFixed(2)} €</span></>
                            )}


                            {tva_inclus && devis.acompte_centimes > 0 && (
                                <>
                                    <span className="font-bold text-left">Solde :</span>
                                    <span className="text-right">{totaux.total_centimes.toFixed(2) - devis.acompte_centimes.toFixed(2)} €</span>
                                </>
                            )}

                            {/* Total final */}

                        </div>


                    </div>



                </div>
            </div>

        </div>
    );
};

export default AddDevis;
